import { DateTime } from "luxon";
export const prezTime = (value) => {
    if( value === undefined)
        return ''

    const theshit = DateTime.fromISO(value)
    const asString = theshit.toFormat("HH:mm:ss")
    if (asString.startsWith("00:")) {
        return asString.substring(3)
    } else if (asString.startsWith("0")) {
        return asString.substring(1)
    }
    return (theshit.toFormat("HH:mm:ss"))
    
    // // console.log( value)
    // const timeAsMoment = value.length > 12 ? new moment.tz( value, "YYYY-MM-DDTHH:mm:ss.SSS", "Europe/Oslo") : new moment( value, "HH:mm:ss.SSS")
    // // console.log( timeAsMoment.format())
    // if( timeAsMoment.isValid()) {
    //     // return timeAsMoment.format()
    //     return timeAsMoment.format("HH:mm:ss")
    // }
    // return ''
}
// export const prezTime = (value) => {
//     if( value && value.length === 2) {
//         return value[0]+":"+pad( value[1], 2)
//     }
//     else if( value && value.length === 3) {
//         return value[0]+":"+pad( value[1], 2)+":00"
//     }
//     else if( value && value.length === 4) {
//         return value[0]+":"+pad( value[1], 2)+":"+pad( value[2], 2)
//     }
//     else if( value && value.length > 5) {
//         return value[3]+":"+pad( value[4], 2)+":"+pad( value[5], 2)
//     }
//     return ''
// }

export const prezClock = (value) => {
    var d = new Date(value);

    // d.toLocaleString();       // -> "2/1/2013 7:37:08 AM"
    // d.toLocaleDateString();   // -> "2/1/2013"
    return d.toLocaleTimeString("nb"); 
    
}
// function pad(num, size) {
//     var s = num+"";
//     while (s.length < size) s = "0" + s;
//     return s;
// }